export default __webpack_public_path__ + "assets/images/338729093f634da8a29e2700dbac6a33.png";